import React from 'react';
import { Link } from 'react-router-dom';
import { useElectron } from '../hooks/useElectron';

export default function Footer() {
  const isElectron = useElectron();
  if (isElectron) return null;

  return (
    <footer className="mt-auto py-6" style={{ borderTop: '1px solid var(--lx-border)' }}>
      <div className="max-w-6xl mx-auto px-4 sm:px-6 flex flex-wrap items-center justify-center gap-x-5 gap-y-2 text-xs text-gray-600">
        <span>© {new Date().getFullYear()} LearnXops</span>
        <a href="https://learnxops.com" target="_blank" rel="noopener noreferrer"
          className="hover:text-gray-400 transition-colors">
          learnxops.com
        </a>
        <Link to="/download" className="hover:text-gray-400 transition-colors">
          Download App
        </Link>
        <Link to="/support" className="hover:text-gray-400 transition-colors">
          Support
        </Link>
        <a href="/privacy.html" className="hover:text-gray-400 transition-colors">
          Privacy Policy
        </a>
        <a href="/terms.html" className="hover:text-gray-400 transition-colors">
          Terms &amp; Conditions
        </a>
      </div>
    </footer>
  );
}
